module.exports = __webpack_public_path__ + "static/media/cubo.d353f5b6.png";